module.exports = __webpack_public_path__ + "static/img/144.005f7e23.png";